module.exports = __webpack_public_path__ + "img/pixinvent-logo.9cbf2496.png";